/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import swal from 'sweetalert';

export default function ErrorAlert (msg, time = 4000){
   
    swal({
        title: msg,
        icon: "error",
        button: "Acceptar",
        timer: time,
        dangerMode: true
    });
    
   
  }